import { render, staticRenderFns } from "./ResultsSection.vue?vue&type=template&id=0e53f589&"
import script from "./ResultsSection.vue?vue&type=script&lang=js&"
export * from "./ResultsSection.vue?vue&type=script&lang=js&"
import style0 from "./ResultsSection.vue?vue&type=style&index=0&id=0e53f589&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports